import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw3-relative tw3-flex tw3-flex-col tw3-items-center tw3-px-6 tw3-py-10 tw3-text-center sm:tw3-px-10" }
const _hoisted_2 = { class: "tw3-mt-6 tw3-text-xs tw3-font-bold tw3-uppercase tw3-tracking-[0.16em] tw3-text-primary-600" }
const _hoisted_3 = { class: "tw3-mt-2 tw3-text-2xl tw3-font-bold tw3-text-surface-900" }
const _hoisted_4 = { class: "tw3-mt-2 tw3-max-w-lg tw3-text-sm tw3-leading-6 tw3-text-surface-500" }
const _hoisted_5 = {
  key: 0,
  class: "tw3-mt-6 tw3-flex tw3-max-w-lg tw3-items-start tw3-gap-3 tw3-rounded-xl tw3-border tw3-border-surface-200 tw3-bg-surface-50 tw3-p-4 tw3-text-left"
}
const _hoisted_6 = { class: "tw3-text-xs tw3-leading-5 tw3-text-surface-600" }
const _hoisted_7 = ["href"]

import BookingButton from './BookingButton.vue';
import BookingCard from './BookingCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingErrorCard',
  props: {
    actionLabel: {},
    bookingPhone: { default: null },
    description: {},
    eyebrow: {},
    hint: { default: '' },
    title: {}
  },
  emits: ["action"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BookingCard, { class: "tw3-relative tw3-overflow-hidden" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tw3-flex tw3-size-16 tw3-items-center tw3-justify-center tw3-rounded-2xl tw3-bg-primary-50 tw3-text-2xl tw3-text-primary-600 tw3-ring-8 tw3-ring-primary-50/50" }, [
          _createElementVNode("i", { class: "pi pi-exclamation-triangle" })
        ], -1)),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.eyebrow), 1),
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.description), 1),
        (_ctx.hint)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.hint), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.bookingPhone)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "tw3-mt-5 tw3-inline-flex tw3-items-center tw3-gap-2 tw3-rounded-xl tw3-bg-primary-50 tw3-px-4 tw3-py-3 tw3-text-sm tw3-font-semibold tw3-text-primary-700 tw3-transition-colors hover:tw3-bg-primary-100",
              href: `tel:${_ctx.bookingPhone}`
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "pi pi-phone" }, null, -1)),
              _createElementVNode("span", null, "Please call " + _toDisplayString(_ctx.bookingPhone) + " to arrange service by phone instead", 1)
            ], 8, _hoisted_7))
          : _createCommentVNode("", true),
        _createVNode(BookingButton, {
          class: "tw3-mt-6",
          icon: "pi pi-refresh",
          label: _ctx.actionLabel,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action')))
        }, null, 8, ["label"])
      ])
    ]),
    _: 1
  }))
}
}

})